import React, { useContext, useEffect, useState } from 'react'
import AgGrid from '../../../Base/Components/Tables/AgGrid/AgGrid'
import { getPastDueList } from '../../../API/Planning/MasterWip/MasterWipRequest'
import Card from '../../../Base/Components/Card/Card'
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Chart } from 'primereact/chart';
import Loader from '../../../Base/Components/Loader/Loader';
import { colors } from '../../../Styles/Colors';
import { datalabelsBarTop, datalabelsGerencia, datalabelsLineCat, datalabelsLineGerencia, datalabelsLineVentas, datalabelsProduccion } from '../../../utils/KPIs/productionUtils';
import { formatSmallNumber } from '../../../Base/Services/FormatTemplate';
import { ConfigContext } from '../../../Base/Context/ConfigContext/ConfigContext';


const PastDueListScreen = ({ get, statusTemplate }) => {

    const [loading, setLoading] = useState(false)
    const [data, setData] = useState([])
    const [week, setWeek] = useState(null)

    const [chartPastDueAmount, setChartPastDueAmount] = useState({ data: {}, options: {} })
    const [chartPastDueKG, setChartPastDueKG] = useState({ data: {}, options: {} })
    const [chartExportWeek, setchartExportWeek] = useState({ data: {}, options: {} })

    const { config } = useContext(ConfigContext)


    let colorText = config?.theme === 'Dark' ? '#FFF' : '#000'


    const getInfo = async () => {
        setLoading(true)

        const [readyToShipPD, exportWeek, exportWeekCotton, exportWeekSynthetic, table] = await getPastDueList();
        setData(table)
        let PdCotton = exportWeek.map(e => {
            if (exportWeekCotton.find(f => f.ExportWeek === e.ExportWeek)) {
                return exportWeekCotton.filter(f => f.ExportWeek === e.ExportWeek)[0]
            } else {
                return { exportWeek: e.exportWeek, AcabadoKg: 0, Amount: 0 }
            }
        })

        let PdSyntheric = exportWeek.map(e => {
            if (exportWeekSynthetic.find(f => f.ExportWeek === e.ExportWeek)) {
                return exportWeekSynthetic.filter(f => f.ExportWeek === e.ExportWeek)[0]
            } else {
                return { exportWeek: e.exportWeek, AcabadoKg: 0, Amount: 0 }
            }
        })


        const chartAmount = {
            labels: readyToShipPD.map(e => e.Customer),
            datasets: [
                {
                    label: 'Past Due ($)',
                    backgroundColor: colors.borderColorSintetico,
                    data: readyToShipPD.map(e => e.Amount),
                },
            ]
        }
        const chartKG = {
            labels: readyToShipPD.map(e => e.Customer),
            datasets: [
                {
                    label: 'Past Due (kg)',
                    backgroundColor: colors.borderColorCotton,
                    data: readyToShipPD.map(e => e.AcabadoKg),
                },
            ]
        }
        const options = {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
                datalabels: {
                    borderRadius: 4,
                    align: 'end',
                    anchor: 'end',
                    borderWidth: 2,
                    marginButtom: 10,
                    padding: 6,
                    offset: 5,
                    font: {
                        weight: 'bold',
                        size: 11
                    },
                    color: colorText,
                    formatter: (value, context) => {
                        if (value === 0 || value === null) {
                            return null
                        }
                        return "$ " + (value / 1000).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",") + " K"
                    },
                },
                legend: {
                    display: true,
                    labels: {
                        color: colorText,
                        font: {
                            size: 11,
                        },
                    },
                },
            },
            scales: {
                x: {
                    ticks: {
                        color: colorText,
                    },
                },
                y: {
                    ticks: {
                        color: colorText,
                    },
                }
            }
        }
        setChartPastDueAmount({
            data: chartAmount,
            options: options
        })
        setChartPastDueKG({
            data: chartKG,
            options: {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    datalabels: {
                        borderRadius: 4,
                        align: 'end',
                        anchor: 'end',
                        borderWidth: 2,
                        marginButtom: 10,
                        padding: 6,
                        offset: 5,
                        font: {
                            weight: 'bold',
                            size: 11
                        },
                        color: colorText,
                        formatter: (value, context) => {
                            if (value === 0 || value === null) {
                                return null
                            }
                            return (value / 1000).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",") + " K"
                        },
                    },
                    legend: {
                        display: true,
                        labels: {
                            color: colorText,
                            font: {
                                size: 11,
                            },
                        },
                    }
                },
                scales: {
                    x: {
                        ticks: {
                            color: colorText,
                        },
                    },
                    y: {
                        ticks: {
                            color: colorText,
                        },
                    }
                }
            },

        })


        // EXPORT WEEK
        console.log({ colorText });

        const chartExportWeekData = {
            labels: exportWeek.map(e => e.ExportWeek),
            color: colorText,
            datasets: [
                {
                    label: 'Past Due Cotton (Kg)',
                    backgroundColor: colors.borderColorCotton,
                    data: PdCotton.map(e => e.AcabadoKg),
                    color: colorText
                },
                {
                    label: 'Past Due Synthetic (Kg)',
                    backgroundColor: colors.borderColorSintetico,
                    data: PdSyntheric.map(e => e.AcabadoKg),
                },
            ]
        }

        setchartExportWeek({
            data: chartExportWeekData,
            options: {
                responsive: true,
                maintainAspectRatio: false,
                color: colorText,
                plugins: {
                    datalabels: {
                        borderRadius: 4,
                        align: 'end',
                        anchor: 'end',
                        borderWidth: 2,
                        marginButtom: 10,
                        padding: 6,
                        offset: 5,
                        font: {
                            weight: 'bold',
                            size: 11
                        },
                        color: colorText,
                        formatter: (value, context) => {
                            if (value === 0 || value === null) {
                                return null
                            }
                            return formatSmallNumber(value) + " Kg"
                        },
                    },
                    legend: {
                        display: true,
                        labels: {
                            color: colorText,
                            font: {
                                size: 11,
                            },
                        },
                    }
                },
                scales: {
                    x: {
                        ticks: {
                            color: colorText,
                        },
                    },
                    y: {
                        ticks: {
                            color: colorText,
                        },
                    }
                }
            }
        })
        setLoading(false)
    }

    const rowClassRules = {
        'ag-rows-partida-red': (params) => { return true },
    }

    const columns = [
        {
            field: 'PlanningDate',
            header: 'Fecha',
            headerEn: 'Date',
            className: '',
            Format: 'Date',
        },
        {
            field: 'ExportWeek',
            header: 'Export Week',
            headerEn: '',
            className: 'Xsmall',
            Format: 'Center',
            sort: 'asc'
        },
        {
            field: 'SalesOrder',
            header: 'Sales Order',
            headerEn: '',
            className: '',

        },
        {
            field: 'Customer',
            header: 'Customer',
            headerEn: '',
            className: '',
            flex: 1,
            minWidth: 200,
        },
        {
            field: 'StyleCategory',
            header: 'Category',
            headerEn: '',
            className: 'Xsmall',
            sort: 'asc'
        },
        {
            field: 'Style',
            header: 'Style',
            headerEn: '',
            className: '',
        },
        {
            field: 'Color',
            header: 'Color',
            headerEn: '',
            className: '',
        },
        {
            field: 'AcabadoKg',
            header: 'Kg',
            headerEn: '',
            className: 'small',
            Format: 'Currency',
            Sumary: 'sum',
            Frozen: true,
            alignFrozen: 'right',
        },
        {
            field: 'Amount',
            header: 'Amount',
            headerEn: '',
            className: 'small',
            Format: 'Currency',
            Sumary: 'sum',
            Frozen: true,
            alignFrozen: 'right',
        },

    ]

    const table = {
        Columns: columns,
        Data: data,
        // loading: loading,
        // rowClassRules: rowClassRules
    }

    useEffect(() => {
        getInfo();
    }, [get, config])


    return (
        <div style={{ height: '85vh' }} className='p-3'>
            <div className='d-flex'>
                <div className="col-12">
                    <Loader loading={loading} />
                    <Card
                        titulo={<div>
                            Ready to Ship (Past Due)
                        </div>}
                        contenido={<div className='col-12 d-flex gap'>
                            <div className="col-6">
                                <Chart height={'340px'} width='100%' type='bar' data={chartPastDueAmount.data} options={chartPastDueAmount.options} plugins={[ChartDataLabels]} />
                            </div>
                            <div className="col-6">
                                <Chart height={'250px'} width='100%' type='bar' data={chartExportWeek?.data} options={chartExportWeek?.options} plugins={[ChartDataLabels]} />
                            </div>
                        </div>}
                    />
                </div>
            </div>
            <div className='pt-3' style={{ height: '42vh' }}>
                <AgGrid table={table} />
            </div>
            {/* <AgGrid table={table} /> */}
        </div>
    )
}

export default PastDueListScreen